import { Select, Stack, Text } from '@mantine/core';
import { i18n } from '@lingui/core';
import { IconChevronDown } from '@tabler/icons';
import { useContext } from 'react';
import SkeletonItems from '../../Atoms/SkeletonItems';
import { DataS } from '../../Service/DataS';
import { QuestionnaireContext } from '../../Service/QuestionnaireContextV2';
import { ContractSign, CustomerSignType } from '../../Types/DocumentT';

const QuestionnaireSignatureSection = () => {
  const { loading, questionnaire, patchQuestionnaire } = useContext(QuestionnaireContext);
  const { contractSign, customerSignType } = questionnaire ?? {};

  return (
    <>
      <Text weight="bolder" size="lg" mb="md" mt="md">
        Unterschrift
      </Text>
      <Text mb="md">Definieren Sie, wie die Signatur angezeigt/erfasst werden soll</Text>
      {loading && <SkeletonItems height={40} count={2} />}
      {!loading && (
        <Stack sx={{ maxWidth: 600 }}>
          <Select
            value={contractSign}
            label={i18n._('contract.sign')}
            data={DataS.getContractSignOptions(i18n)}
            onChange={(val: ContractSign) => patchQuestionnaire({ contractSign: val })}
            styles={{ rightSection: { pointerEvents: 'none' } }}
            rightSection={<IconChevronDown size={14} />}
            rightSectionWidth={25}
          />
          <Select
            disabled={contractSign === 'NONE'}
            value={customerSignType}
            label={i18n._('contract.sign.type')}
            data={DataS.getCustomerSignTypeOptions(i18n)}
            onChange={(val: CustomerSignType) => patchQuestionnaire({ customerSignType: val })}
            styles={{ rightSection: { pointerEvents: 'none' } }}
            rightSection={<IconChevronDown size={14} />}
            rightSectionWidth={25}
          />
        </Stack>
      )}
    </>
  );
};

export default QuestionnaireSignatureSection;
